import { Component, OnInit, Input, OnDestroy } from '@angular/core';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.sass']
})
export class CountdownComponent implements OnInit, OnDestroy {
  @Input() date: any = {};

  days = 0;
  hours = 0;
  minutes = 0;
  seconds = 0;
  timer;

  constructor() { }

  ngOnInit() {
    this.refreshTimer();

    this.timer = setInterval(() => {
      this.refreshTimer();
    }, 1000);
  }

  refreshTimer() {
    const date = new Date(this.date).getTime();
    const now = new Date().getTime();
    const distance = date - now;

    this.days    = Math.floor(distance  / (1000 * 60 * 60 * 24));
    this.hours   = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    this.seconds = Math.floor((distance % (1000 * 60)) / 1000);

    if (distance < 0) {
      this.days = 0;
      this.hours = 0;
      this.minutes = 0;
      this.seconds = 0;
      clearInterval(this.timer);
    }
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

}
